import { WatchedLoadModel } from "../../models/home/WatchedLoads.model";
import { IUserDetails } from "../../schemas/user";
import * as Constants from '../../utils/constants';

const pageSize = 25;

 /**
   * Method is for fetching latest watched loads with request payload structure. 
   * @param {Object} userDetails user details properties.
   * @param {Function} watchedData Function to be dispatched.
   * @param {Function} setPaginationValues Function to be trigger defualt pagination values.
   * @param {Object} refreshStatus user details properties.
   * @param {Object} page user details properties.
   * @param {Function} callback call back functional to be called.
   * @param {roles} sortColumn sorting option value.
   * @param {String} sortDirection soring direction.
   * @param {Array} roles collection of Role names.
   * @returns {Component} returns wrapped component.
  */
export const getWatchedLoads = (
  userDetails: IUserDetails,
  watchedData: Function,
  setPaginationValues:Function,
  refreshStatus = false,
  page = 0,
  callback: any = false,
  sortColumn = Constants.pickUpStartDate,
  sortDirection: string = Constants.SORTING_ORDER_ASC,
  roles:any = [],
  isPullToRefresh:boolean = false
) => {
  refreshStatus && setPaginationValues();
  if (!(!!(userDetails && userDetails.memberDetailsResponse &&
    userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.carrierId))) {
    return;
  }

  const watchedLoadModel: WatchedLoadModel = new WatchedLoadModel();
  watchedLoadModel.carrierId =userDetails && userDetails.memberDetailsResponse &&
  userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.carrierId;
  watchedLoadModel.page = page;
  watchedLoadModel.userId = (userDetails && userDetails.memberDetailsResponse &&
    userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.upn) || '';
  watchedLoadModel.size = pageSize;
  watchedLoadModel.sortDirection = sortDirection;
  watchedLoadModel.sortColumn = sortColumn;
  watchedLoadModel.userRole = roles.join(',') || '';
  watchedLoadModel.managedEquipmentCapability = userDetails && userDetails.memberDetailsResponse &&
  userDetails.memberDetailsResponse.carrierInfo && userDetails.memberDetailsResponse.carrierInfo.managedEquipmentCapability;
  watchedLoadModel.nonManagedEquipmentCapability = userDetails && userDetails.memberDetailsResponse &&
  userDetails.memberDetailsResponse.carrierInfo && userDetails.memberDetailsResponse.carrierInfo.nonManagedEquipmentCapability;

  return watchedData({
    query: watchedLoadModel.getRequestPayload(),
    refreshStatus,
    callback,
    isPullToRefresh
  });

};